// prettier-ignore
export const NamedNeurons = {
    "afdbb46396374af0baad270f06e738fbf60997359e3f1bbea2293312e3278aef": "OpenChat Dev Team",
    "2e6deec3460a3b74d4b9077462cacc36c9f3403577c8fbf4a9babe25799b7f8b": "OpenChat ProposalsBot",
    "54f9ba2b0e81a17f5261b277abd91816e041c5ca749ba88b3dbe05f66bb6124d": "HotOrNot Dev Team",
    "f513314523830ed270c65c4fa2bd6473b2bba3e4faf91b0e0782bf21c2e4ab25": "Dragginz Dev Team",
    "9641cdd7c4f487c1ed146b7abb3ee9d38a4e77cadc681bf1cc091439011e3f87": "Kinic Developer Organization",
    "2d92f39b8937c4cbb92796e04b62d3c0b235820f031856b8f250e37917e18730": "Kinic Developer Organization",
    "266e91dbb8d435de82a7d961f0ac0060015a597a4e542d9e7f30a488cab8a592": "Kinic Developer Organization",
    "eda6976220ea999ed4d5df28b217e4d452786b6c9dc8f3d892256eaca00017ce": "ICX Dev Team",
    "fd052a2a6648357c984cd8a04edcb9e34a48967a46f44db9264f5156d7e96c61": "Modclub Foundation",
    "90699f782a035b3e4510c1d27234cc05ef3cd96059972d60ffd506ffd8a63bfd": "Sonic Dev Team",
    "0de364d62cf2a717e5ae867f0d17e9a0d29701b44a2d7087328d42a9ccaa423f": "the CTS-TEAM"
};
